import { Dropdown, Menu } from "antd";
import React from "react";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { FaEdgeLegacy } from "react-icons/fa";

interface UIModulePageProps {
  handleEdit: (record: any) => void;
  handleLink: (record: any) => void;
  handleDelete: (record: any) => void;
  setIsHovered: (isHovered: boolean) => void;
  key: any;
  expandedRowKey?: any;
  record: {
    name: string;
    [key: string]: any;
  };
  isHovered: boolean;
}

const UIModulePage: React.FC<UIModulePageProps> = (props) => {
  const { handleEdit, handleLink, handleDelete, setIsHovered, record } = props;

  const menu = (
    <Menu>
      <Menu.Item key="link" onClick={() => handleLink(record)}>
        <FaEdgeLegacy style={{ marginRight: "6px", color: "#38a169" }} />
        Link
      </Menu.Item>
      <Menu.Item key="edit" onClick={() => handleEdit(record)}>
        <AiOutlineEdit style={{ marginRight: "6px", color: "#3182ce" }} />
        Edit
      </Menu.Item>
      <Menu.Item key="delete" onClick={() => handleDelete(record)}>
        <AiOutlineDelete style={{ marginRight: "6px", color: "#e53e3e" }} />
        Delete
      </Menu.Item>
    </Menu>
  );

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Dropdown
        overlay={menu}
        trigger={["hover"]}
        overlayClassName="access-rights-cell-menu"
        mouseEnterDelay={0.2}
      >
        <div className="access-rights-pages-cell is-component">
          <span className="access-rights-cell-dot" />
          {record?.name}
        </div>
      </Dropdown>
    </div>
  );
};

export default UIModulePage;
